import { FormControl, FormHelperText, InputLabel, Stack } from '@mui/material'
import { PropsWithChildren } from 'react'

import Tooltip from 'components/Tooltip'
import { SelectProps } from '../types'

export type Props<T> = Pick<
  SelectProps<T>,
  'disabled' | 'error' | 'helperText' | 'label' | 'name' | 'tooltip'
> &
  PropsWithChildren

export const SelectContainer = <T,>({
  children,
  disabled,
  error,
  helperText,
  label,
  name,
  tooltip,
}: Props<T>): JSX.Element => (
  <Stack direction='row'>
    <FormControl
      data-cy={`select-${name}`}
      error={error}
    >
      {label && (
        <InputLabel
          data-cy={`select-label-${name}`}
          disabled={disabled}
          id={`${name}-label`}
          shrink
        >
          {label}
        </InputLabel>
      )}

      {children}

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>

    {tooltip && <Tooltip {...tooltip} />}
  </Stack>
)
